// @flow
import React, { useEffect } from 'react';
import { Col, Row } from 'react-flexbox-grid';

import Input from '../Input';
import Label from '../Label';
import Select from '../Select';
import { countryDivisions } from '../../utils/countries';
import styles from './createUserForm.css';
import { values } from 'lodash';

const defaultValue = {
  address1: 'Guatemala',
  address2: '',
  address3: '',
  address4: '',
  address5: '',
  address6: '',
};

type AddressInputProps = {
  value: any;
  onChange: Function;
}

const AddressInput = ({
  value = defaultValue,
  onChange,
}: AddressInputProps) => {
  const region = Object.keys(countryDivisions.Guatemala).map(x => ({ value: x, label: x }));
  const subRegion = (countryDivisions.Guatemala[value.address3] || []).map(x => ({ value: x, label: x }))
  const changeAddress = (key: string, newValue: any) => {
    onChange({
      ...value,
      [key]: newValue,
    });
  };

  return (
    <>
      <Row>
        <Col className={styles.input} xs={12}>
          <Label>Dirección:</Label>
        </Col>
      </Row>
      <Row>
        <Col className={styles.input} xs={6}>
          <Input
            placeholder="Ej. 6 Avenida B-34"
            value={value.address2}
            onChange={e => changeAddress('address2', e.target.value)}
          />
        </Col>
        <Col className={styles.input} xs={6}>
          <Input
            placeholder="Ej. Colonia Las Colinas Zona 12"
            value={value.address3}
            onChange={e => changeAddress('address3', e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col className={styles.input} xs={4}>
          <Label>Departamento</Label>
          <Select
            options={region}
            value={value.address4}
            onChange={newValue => {
              onChange({
                ...value,
                address4: newValue,
                address5: '',
              });
            }}
            placeholder="Ej. Guatemala"
          />
        </Col>
        <Col className={styles.input} xs={4}>
          <Label>Municipio</Label>
          <Select
            options={subRegion}
            value={value.address5}
            onChange={newValue => changeAddress('address5', newValue)}
            placeholder="Ej. Mixco"
          />
        </Col>
        <Col className={styles.input} xs={4}>
          <Label>*Código postal</Label>
          <Input
            placeholder="01021"
            value={value.address6}
            onChange={e => changeAddress('address6', e.target.value)}
          />
        </Col>
      </Row>
    </>
  );
};

export default AddressInput;



// WEBPACK FOOTER //
// ./src/scripts/components/CreateUserForm/AddressInput.jsx